import { render, staticRenderFns } from "./business-plan-page-wrapper.component.vue?vue&type=template&id=70b92057&scoped=true"
import script from "./business-plan-page-wrapper.component.vue?vue&type=script&lang=ts"
export * from "./business-plan-page-wrapper.component.vue?vue&type=script&lang=ts"
import style0 from "./business-plan-page-wrapper.component.vue?vue&type=style&index=0&id=70b92057&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b92057",
  null
  
)

export default component.exports